import { NeedsDriversLicensePhotoUploadedOutboundTripDetailDto } from 'dtos/toDoLists/outboundTrips/NeedsDriversLicensePhotoUploadedOutboundTripDetailDto'
import * as yup from 'yup'

export const NeedsDriversLicensePhotoUploadedOutboundTripDetailValidator = yup.object<NeedsDriversLicensePhotoUploadedOutboundTripDetailDto>({
  driversLicensePhotoFile: yup.mixed().required('Drivers License Photo is required.')
})
